import { observable, action, makeObservable, computed } from "mobx";
import {LZ, SystemUser} from "../../models/user/user";
import {DisplayType} from "../../components/core/commons/price/price.helper";

export class AuthStore {

    @observable
    private _originalUsername: string | undefined;

    @observable
    private _registered: boolean = false;// !!localStorage.getItem("registered");

    @observable
    private _token: string = "";

    @observable
    private _defaultServer: string = "";

    @observable
    private _availableServers: string[] = [];

    @observable
    private _user: SystemUser | null = null;

    @observable
    private _attributes: string[] = [];

    @observable
    private _inited: boolean = false;

    @observable
    private _isInvalidCredentials: boolean | null = null;

    @observable
    private _isLogging: boolean = false;

    @observable
    private _userBranch: string = "";

    @observable
    private _access: number = 0;

    @observable
    private _closed: boolean = false;

    @observable
    private _selectedCurrencyCode: string = "";

    @observable
    private _currencyCodes: string[] = [];

    @observable
    private _timezone: string = '';

    @observable
    private _lz: LZ = {
        pt: DisplayType.COMMA,
        py: false,
        tz: '',
        mw: true
    };

    constructor() {
        makeObservable(this);
    }

    @computed
    public get branch(): string {
        return this._userBranch;
    }

    private set userBranch(value: string) {
        this._userBranch = value;
    }

    @action
    public setUserBranch(value: string): void {
        this.userBranch = value;
    }

    @computed
    public get registered(): boolean {
        return this._registered;
    }

    private set isRegistered(value: boolean) {
        this._registered = value;
    }

    @computed
    public get closed(): boolean {
        return this._closed;
    }

    public set closed(value: boolean) {
        this._closed = value;
    }

    @computed
    public get selectedCurrencyCode(): string {
        return this._selectedCurrencyCode;
    }

    public set selectedCurrencyCode(value: string) {
        this._selectedCurrencyCode = value;
    }

    @computed
    public get currencyCodes(): string[] {
        return this._currencyCodes;
    }

    public set currencyCodes(value: string[]) {
        this._currencyCodes = value;
    }

    @computed
    public get timezone(): string {
        return this._timezone;
    }

    public set timezone(value: string) {
        this._timezone = value;
    }

    @action
    public setRegistered(value: boolean): void {
        this.isRegistered = value;
    }

    @computed
    public get logging(): boolean {
        return this._isLogging;
    }

    public set isLogging(value: boolean) {
        this._isLogging = value;
    }

    @computed
    public get isInvalidCredentials(): boolean | null {
        return this._isInvalidCredentials;
    }

    public set isInvalidCredentials(value: boolean | null) {
        this._isInvalidCredentials = value;
    }

    @computed
    public get user(): SystemUser | null {
        return this._user;
    }

    public set user(value: SystemUser | null) {
        this._user = value;
    }

    @computed
    public get attributes(): string[] {
        return this._attributes;
    }

    public set attributes(value: string[]) {
        this._attributes = value;
    }

    @computed
    public get inited(): boolean {
        return this._inited;
    }

    private set loaded(value: boolean) {
        this._inited = value;
    }

    @computed
    public get isLoggedIn(): boolean {
        return null !== this._user;
    }

    @computed
    public get token(): string {
        return this._token;
    }

    @computed
    public get hasToken(): boolean {
        return !!this._token;
    }

    public set token(token: string) {
        this._token = token;
    }

    public get defaultServer(): string {
        return this._defaultServer;
    }

    public set defaultServer(value: string) {
        this._defaultServer = value;
    }

    public get availableServers(): string[] {
        return this._availableServers;
    }

    public set availableServers(value: string[]) {
        this._availableServers = value;
    }

    @action
    public setToken(token: string) {
        this.token = token;
    }

    @action
    public setUser(user: SystemUser | null) {
        this.user = user;
    }

    @action
    public setInited(value: boolean): void {
        this.loaded = value;
    }

    @action
    public setClosed(value: boolean): void {
        this.closed = value;
    }

    @action
    public setSelectedCurrencyCode(value: string): void {
        this.selectedCurrencyCode = value;
    }

    @action
    public setCurrencyCodes(value: string[]): void {
        this.currencyCodes = value;
    }

    @action
    public setAttributes(attributes: string[]): void {
        this.attributes = attributes;
    }

    @action
    public setIsInvalidCredentials(value: boolean | null): void {
        this.isInvalidCredentials = value;
    }

    @action
    public setLogging(value: boolean): void {
        this.isLogging = value;
    }

    @action
    public getAccess(): number {
        return this._access;
    }

    @action
    public setAccess(value: number | null) {
        if (this._access !== value) {
            this._access = value || 0;
        }
    }

    @action
    public setOriginalUsername(value: string | undefined) {
        this._originalUsername = value;
    }

    @computed
    public get isUserFaked(): boolean {
        return !!this.originalUsername;
    }

    @computed
    public get originalUsername(): string | undefined {
        return this._originalUsername;
    }

    @action
    public setLZ(value: LZ) {
        this._lz = value;
    }

    @action
    public getTimezone(): string {
        return this._timezone;
    }

    @action
    public setTimezone(value: string) {
        this._timezone = value;
    }

    get lz(): LZ {
        return this._lz;
    }

    set lz(value: LZ) {
        this._lz = value;
    }
}
